/** Route data selects the page; subsequent config revisions supply its current content. */
export function selectCurrentPage<T extends { id: string }>(routePage: T, pages: readonly T[] | undefined): T | undefined {
  return pages === undefined ? routePage : pages.find((page) => page.id === routePage.id);
}
